import React from "react";

import logo from "../assets/images/logo.png";
import mr1 from "../assets/images/1.png";
import mr2 from "../assets/images/2.png";
import mr3 from "../assets/images/3.png";
import mr4 from "../assets/images/4.png";
import mr5 from "../assets/images/5.png";
import mr6 from "../assets/images/6.png";
import mr7 from "../assets/images/7.png";
import mr8 from "../assets/images/9.png";
import mr9 from "../assets/images/9.png";
import mr10 from "../assets/images/10.png";
import mr11 from "../assets/images/11.png";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import {useTranslation} from "react-i18next";
const Carrousel = () => {
  const [ t ] = useTranslation(['home']);
  return (
    <div>
      <div className="container pt-5 pb-5 " id="NFTsSection">
        <div className="row pt-5">
          <div className="col-12 col-lg-6 mt-5 pt-5">
            <br />
            <label className="section-subtitle">{t('LatestReleases')}</label>
            <h1 className="section-title rleft">{t('Collection')} mr crypto</h1>
            <p className="section-description">
              {t('DiscoverOurLatest')}  <span>{t('NFTCollection')}</span> {t('DifferentRaritiesAnd')} <br />
              {t('AssetsThatWillMake')} <span>{t('UniquePiece')}</span>
            </p>
            <a
              target="_blank"
              href="https://opensea.io/collection/mrcrypto-by-racksmafia"
              className="btn-native-child"
            >
              {t('SeeAtOenSea')}
            </a>
          </div>
        </div>
      </div>
      <div>
        <OwlCarousel
          className="owl-theme"
          autoplay={true}
          center={true}
          nav={true}
          items={7}
          loop
          nav
        >
          <div className="item">
            <img className="" src={mr1} />
          </div>
          <div className="item">
            <img className="" src={mr2} />
          </div>
          <div className="item">
            <img className="" src={mr3} />
          </div>
          <div className="item">
            <img className="" src={mr4} />
          </div>
          <div className="item">
            <img className="" src={mr5} />
          </div>
          <div className="item">
            <img className="" src={mr6} />
          </div>
          <div className="item">
            <img className="" src={mr7} />
          </div>
          <div className="item">
            <img className="" src={mr9} />
          </div>
          <div className="item">
            <img className="" src={mr10} />
          </div>
          <div className="item">
            <img className="" src={mr11} />
          </div>
        </OwlCarousel>
      </div>
    </div>
  );
};

export default Carrousel;
